import { Outlet, NavLink, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '@ui/components/Sidebar/Sidebar';
import BottomTabs from '@ui/components/BottomTabs/BottomTabs';
import { AchievementToast } from '@ui/components/AchievementToast/AchievementToast';
import Footer from '@ui/components/Footer/Footer';
import { usePageTitle } from '../hooks/usePageTitle';
import { ROUTES } from '../../routes';
import BetaBanner from '@ui/components/BetaBanner/BetaBanner';
import AppInstallBanner from '@ui/components/AppInstallBanner/AppInstallBanner';
import { logEvent } from '../../infra/firebase/analytics';
import { AnalyticsEvent } from '../../domain/analytics';
import styles from './AuthenticatedLayout.module.css';

export default function AuthenticatedLayout() {
  const pageTitle = usePageTitle();
  const location = useLocation();
  const navigate = useNavigate();
  const isSecondLevel = location.pathname.split('/').filter(Boolean).length > 1;

  return (
    <div className={styles.root}>
      <Sidebar />

      <div className={styles.content}>
        <AppInstallBanner
          onView={() => logEvent(AnalyticsEvent.appBannerView)}
          onCtaClick={() => logEvent(AnalyticsEvent.appBannerClick)}
          onDismiss={() => logEvent(AnalyticsEvent.appBannerDismiss)}
        />
        <BetaBanner
          dismissible
          onView={() => logEvent(AnalyticsEvent.betaBannerView)}
          onDismiss={() => logEvent(AnalyticsEvent.betaBannerDismiss)}
        />
        <header className={styles.mobileHeader}>
          {isSecondLevel ? (
            <button className={styles.mobileBackButton} onClick={() => navigate(-1)} aria-label="Go back">
              ← {pageTitle}
            </button>
          ) : (
            <NavLink to={ROUTES.loggedInHome} className={styles.mobileBrand}>
              <span className={styles.mobileLogo} aria-hidden="true" />
              breath lab
            </NavLink>
          )}
        </header>

        <header className={styles.desktopTopBar}>
          <div className={styles.desktopTopBarInner}>
            <div className={styles.topBarLeft}>
              {isSecondLevel && (
                <button className={styles.backButton} onClick={() => navigate(-1)} aria-label="Go back">
                  ←
                </button>
              )}
              {pageTitle && <h1 className={styles.topBarTitle}>{pageTitle}</h1>}
            </div>
          </div>
        </header>

        <main className={styles.main}>
          <Outlet />
        </main>

        <div className={styles.desktopFooter}>
          <Footer />
        </div>
      </div>

      <BottomTabs />
      <AchievementToast />
    </div>
  );
}
